<div box *ngIf="state$ | async as state">
  <div title>Acknowledge Email</div>

  <div *ngIf="isLoading" class="pt-4 pb-8 text-left">
    Loading...
  </div>

  <div *ngIf="!isLoading && isInvalid" class="pt-4 pb-8 text-left">
    This acknowledgement link is invalid.
    <div class="text-center pt-4">
      <a [href]="environment.websiteUrl">Back to website</a>
    </div>
  </div>

  <div *ngIf="!isLoading && !isInvalid && state.status === 'EXPIRED' && !canRedirect(state.redirectUrl)" class="pt-4 pb-8 text-left">
    This acknowledgement link has expired.
    <div class="text-center pt-4">
      <a [href]="environment.websiteUrl">Back to website</a>
    </div>
  </div>

  <div *ngIf="!isLoading && !isInvalid && state.status === 'DELIVERY_FAILED' && !canRedirect(state.redirectUrl)" class="pt-4 pb-8 text-left">
    We couldn't complete your acknowledgement right now. Please try the link in your email again later.
    <div class="text-center pt-4">
      <a [href]="environment.websiteUrl">Back to website</a>
    </div>
  </div>

  <div *ngIf="!isLoading && !isInvalid && state.status === 'ALREADY_ACKNOWLEDGED' && !canRedirect(state.redirectUrl)">
    <div class="pt-4 pb-8 text-left">
      You have already acknowledged receipt of this email{{ state.acknowledgeTimestamp ? ' on ' + (state.acknowledgeTimestamp | date: 'medium') : '' }}.
    </div>

    <button nzSize="large" [routerLink]="['/', 'login']" type="button" nz-button nzBlock nzType="primary">
      Back to website
    </button>
  </div>

  <div *ngIf="!isLoading && !isInvalid && state.status === 'FRESH' && state.hasCustomLandingPage" class="pt-4 pb-8 text-left">
    Processing...
  </div>

  <div *ngIf="!isLoading && !isInvalid && state.status === 'FRESH' && !state.hasCustomLandingPage">
    <div class="pt-4 pb-4 text-left">
      This email was sent to: <strong>{{ state.recipientEmail }}</strong>
    </div>
    <div class="pt-4 pb-4 text-left">
      Please confirm that you have received this email.
    </div>
    <button [nzLoading]="isLoading" (click)="submitForm()" nzSize="large" nz-button nzBlock nzType="primary">
      Acknowledge
    </button>
    <div class="text-center pt-4">
      <a [href]="environment.websiteUrl">Back to website</a>
    </div>
  </div>
</div>
